<template>
  <div class="team-view-roster">
    <h3 class="team-view-roster__title">Список участников:</h3>
    <ul class="team-view-roster__list">
      <li
        v-for="(member, index) in roster"
        :key="index"
        class="team-view-roster__item"
      >
        <TeamViewRosterMember
          :disabled="isDisabled"
          :member="member"
          :index="index + 1"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import TeamViewRosterMember from "./TeamViewRosterMember";
import { mapState, mapGetters } from "vuex";

export default {
  name: "TeamViewRoster",
  components: {
    TeamViewRosterMember
  },
  computed: {
    ...mapState("team", ["team"]),
    ...mapGetters("team", ["isDisabled"]),
    roster() {
      const array = [...this.team.players];
      array.length = 6;
      return array;
    }
  }
};
</script>

<style lang="scss">
.team-view-roster {
  margin-top: 30px;
  &__title {
    font-size: 24px;
    color: colors(text-2);
    font-weight: fw(bold);
    margin-bottom: 30px;
    text-transform: uppercase;
  }

  &__list {
    @include nl();
  }

  &__item {
    &:not(:last-child) {
      margin-bottom: 5px;
    }
  }
}
</style>
